import './App.scss';
import ArcadeAudio from './components/arcadeAudio';

function App() {
  return (
    <div className="container">
      <ArcadeAudio />
    </div>
  );
}

export default App;
